<div class="products mb-3 skeleton-body skel-shop-products" [class.loaded]="loaded">
    <p class="no-results" *ngIf="(products.length == 0 && loaded) else productBlock">No products were found matching
        your
        selection.</p>
    <ng-template #productBlock>
        <div class="row" *ngIf="!loaded else elseBlock">
            <div [class]="cols" *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
                <div class="skel-pro"></div>
            </div>
        </div>
        <ng-template #elseBlock>
            <div class="row">
                <div [ngClass]="cols" *ngFor="let product of products">
                    <molla-product-ten [product]="product" class="product-width"></molla-product-ten>
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>